module.exports = __webpack_public_path__ + "static/phone-carrier-intro-circle-3-786fd2f4b94723a6a7f75ef09bddd007.png";